(function () {
  function decodeValue(value) {
    let next = String(value == null ? '' : value);
    for (let i = 0; i < 2; i += 1) {
      try {
        const decoded = decodeURIComponent(next.replace(/\+/g, ' '));
        if (decoded === next) break;
        next = decoded;
      } catch (error) {
        break;
      }
    }
    return next.toLowerCase().trim();
  }

  function collectionHandle(pathname) {
    const match = String(pathname || '').toLowerCase().match(/\/collections\/([^/]+)/);
    return match ? match[1] : '';
  }

  function urlFromHref(href) {
    try {
      return new URL(href, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function filtersFromSearch(search) {
    const params = new URLSearchParams(search || '');
    const filters = new Map();

    params.forEach((value, key) => {
      if (!key.toLowerCase().startsWith('filter.')) return;
      const normalizedKey = decodeValue(key);
      const group = filters.get(normalizedKey) || [];
      group.push(decodeValue(value));
      filters.set(normalizedKey, group);
    });

    return filters;
  }

  function valuesMatch(linkValue, currentValue) {
    return (
      linkValue === currentValue ||
      currentValue.indexOf(linkValue) !== -1 ||
      linkValue.indexOf(currentValue) !== -1
    );
  }

  function scoreLink(href, currentHandle, currentFilters) {
    const parsed = urlFromHref(href);
    if (!parsed) return -1;

    const linkHandle = collectionHandle(parsed.pathname);
    if (currentHandle && linkHandle && currentHandle !== linkHandle) return -1;
    if (!linkHandle && parsed.pathname.replace(/\/+$/, '') !== window.location.pathname.replace(/\/+$/, '')) {
      return -1;
    }

    const linkFilters = filtersFromSearch(parsed.search);
    if (linkFilters.size === 0) {
      return currentFilters.size === 0 ? 0 : -1;
    }

    let matched = 0;
    let unmatched = false;

    linkFilters.forEach((values, key) => {
      const currentValues = currentFilters.get(key) || [];
      values.forEach((value) => {
        if (currentValues.some((currentValue) => valuesMatch(value, currentValue))) {
          matched += 1;
        } else {
          unmatched = true;
        }
      });
    });

    return unmatched ? -1 : matched;
  }

  function applyActiveState(root) {
    if (!root) return;

    const links = Array.from(root.querySelectorAll('.collection-subnav__link[href]'));
    if (!links.length) return;

    const currentHandle = collectionHandle(window.location.pathname);
    const currentFilters = filtersFromSearch(window.location.search);
    const scores = links.map((link) => scoreLink(link.getAttribute('href'), currentHandle, currentFilters));

    let activeIndex = -1;
    let maxScore = -1;
    scores.forEach((score, index) => {
      if (score > maxScore) {
        maxScore = score;
        activeIndex = index;
      }
    });
    if (activeIndex === -1) activeIndex = 0;

    links.forEach((link, index) => {
      const isActive = index === activeIndex;
      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function scrollActiveIntoView(root) {
    if (!root) return;
    const active = root.querySelector('.collection-subnav__link.is-active');
    const list = root.querySelector('.collection-subnav__list');
    if (!active || !list) return;

    const listRect = list.getBoundingClientRect();
    const itemRect = active.getBoundingClientRect();
    const overflowLeft = itemRect.left < listRect.left + 8;
    const overflowRight = itemRect.right > listRect.right - 8;

    if (overflowLeft || overflowRight) {
      active.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }
  }

  function init(root) {
    if (!root) return;
    applyActiveState(root);
    if (root.dataset.csnInit === 'true') return;
    root.dataset.csnInit = 'true';
    scrollActiveIntoView(root);
  }

  function initAll() {
    document.querySelectorAll('[data-collection-subnav]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target) return;
    event.target.querySelectorAll('[data-collection-subnav]').forEach(init);
  });
})();
